export default __webpack_public_path__ + "eaf99481dac3b56f73678298e1b3a972.png";